import { Component, h } from 'preact';
import cx from 'classnames';

import { inputGridGetStyles, InputGridOptions, inputGridCheckFlex } from '../../../core/input-grid';

interface CheckboxGroupProps {
  choices: string[];
  selected: string[];
  showInvalidState?: boolean;

  // Layout options
  layout?: InputGridOptions;
  layoutLg?: InputGridOptions;

  onSelectionChange: (selected: string[]) => void;
}

export class CheckboxGroup extends Component<CheckboxGroupProps> {
  onCheckboxChange(choice: string) {
    const selected = this.props.selected || [];
    let newSelected = [ ...selected ];

    if (selected.includes(choice)) {
      const index = selected.indexOf(choice);
      newSelected.splice(index, 1);
    } else {
      newSelected.push(choice);
      newSelected = newSelected.sort();
    }

    this.props.onSelectionChange(newSelected);
  }

  render(props: CheckboxGroupProps) {
    const selected = props.selected || [];
    const usingFlex = inputGridCheckFlex(props.layout, props.layoutLg);

    return (
      <div style={ inputGridGetStyles(props.choices.length, props.layout, props.layoutLg) }>
        { props.choices.map(choice => (
          <label className={ cx({
            'text-danger': props.showInvalidState,
            'mr-2': !usingFlex,
            'mr-4': usingFlex
          }) }>
            <input type="checkbox"
              checked={ selected.includes(choice) }
              onClick={ () => this.onCheckboxChange(choice) } /> { choice }
          </label>
        )) }
      </div>
    );
  }
}
